import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDistributionByYearsOfExperience } from '../../../../redux/thunks/affinityHubThunk';
import { Box, Typography, Skeleton } from '@mui/material';
import { BarChart } from '../../../shared';
import { CHART_OPTIONS, CHART_SERIES } from './constants';

const DistributionByYearsOfExperience = (props) => {
    const dispatch = useDispatch();
    const { distributionByYearsofExp } = useSelector(state => state.affinityHub);
    const { chartSeries, isLoading } = distributionByYearsofExp;
    useEffect(() => {
        dispatch(getDistributionByYearsOfExperience());
    }, []);

    return (
        <Box className="padding-24px height-280px custom-tool-tip custom-hover-bar-color apexchart-horizontal-bar-chart">
            <Box>
                <Typography className="text-md-semi-bold gray-900">
                    Distribution by Years of Experience
                </Typography>
            </Box>
            { isLoading 
                ? <Skeleton height={'100%'} variant='rounded' /> 
                : <BarChart chartOptions={CHART_OPTIONS} chartSeries={chartSeries} />
            }
        </Box>
    );
};

export default DistributionByYearsOfExperience;
